export default __webpack_public_path__ + "static/media/Foto15.bac7487b.png";